'use client';

import styles from '../../../templates/EpIncidentSteps/EpIncidentSteps.module.scss';
import { useFormContext, useWatch } from 'react-hook-form';
import { EpRadioButton } from '../../../components/HookFormComponents/components/EpRadioButton';
import { EpErrorMessage } from '../components/EpErrorMessage';
import { useTranslation as t } from '../../../hooks/useTranslation';
import { EpStepContent } from '../components';

export default function PersonTypeRadio({
  translations,
}: {
  translations: unknown;
}) {
  const { resetField, formState: { errors } } = useFormContext();
  const controller = 'personType';

  const Person = useWatch({ name: 'person' });
  const isVisible = Person?.inputValue === 'true';

  function handleChange() {
    resetField('unitId.inputValue');
    resetField('unitId.inputLabel');

    resetField('patientIdentification');
    resetField('patientName');
    resetField('genderId');
    resetField('patientBirthDate');



  }

  if (!isVisible) return null;

  return (
    <>
      <div onChange={handleChange}>
        <EpStepContent.Label label={t(translations, 'Is this person a?') + ' *'}>
          <div className={styles['radio__group']}>
            <EpRadioButton
              radioId={`EpRadio__1`}
              radioValue={'1'}
              radioName={controller}
              radioLabel={t(translations, 'Patient')}
              errorMessage={t(translations, '* Required Fied')}
              radioWithError={!!errors[controller]}
            />
            <EpRadioButton
              radioId={`EpRadio__2`}
              radioValue={'2'}
              radioName={controller}
              radioLabel={t(translations, 'Visitor/Guest')}
              errorMessage={t(translations, '* Required Fied')}
              radioWithError={!!errors[controller]}
            />
            <EpRadioButton
              radioId={`EpRadio__3`}
              radioValue={'3'}
              radioName={controller}
              radioLabel={t(translations, 'Employee')}
              errorMessage={t(translations, '* Required Fied')}
              radioWithError={!!errors[controller]}
            />
          </div>
        </EpStepContent.Label>
        <EpErrorMessage inputName={`${controller}.inputValue`} />
      </div>
    </>
  );
}
